import {
  CLEAR_EDIT_EARTHQUAKE_EVENT,
  GET_EDIT_EARTHQUAKE_REQUEST,
  CREATE_EDIT_EARTHQUAKE_REQUEST,
  UPDATE_EDIT_EARTHQUAKE_REQUEST,
  EDIT_EARTHQUAKE_VOLCANO_REQUEST,
  EDIT_EARTHQUAKE_VOLCANO_SEARCH_REQUEST,
  EDIT_EARTHQUAKE_TSUNAMI_REQUEST,
  EDIT_EARTHQUAKE_TSUNAMI_SEARCH_REQUEST,
  EDIT_EARTHQUAKE_REFERENCE_REQUEST,
  EDIT_EARTHQUAKE_REFERENCE_SEARCH_REQUEST,
  EDIT_EARTHQUAKE_COUNTRY_REQUEST,
  EDIT_EARTHQUAKE_REGION_REQUEST,
  EDIT_EARTHQUAKE_AREA_REQUEST,
  EDIT_EARTHQUAKE_LOCATION_REQUEST,
  EDIT_EARTHQUAKE_REFERENCE_SORT,
  EDIT_EARTHQUAKE_TSUNAMI_SORT,
  EDIT_EARTHQUAKE_VOLCANO_SORT,
  EDIT_EARTHQUAKE_OPEN_CONFIRMATION,
  EDIT_EARTHQUAKE_CANCEL_CONFIRMATION,
  EDIT_EARTHQUAKE_REFERENCE_TOGGLE_COLUMN,
  EDIT_EARTHQUAKE_VOLCANO_TOGGLE_COLUMN,
  EDIT_EARTHQUAKE_TSUNAMI_TOGGLE_COLUMN,
} from './earthquakeEditReducer';


export const getEarthquake = ({ id, history }) => ({ type: GET_EDIT_EARTHQUAKE_REQUEST, id, history });
export const clearEarthquake = () => ({ type: CLEAR_EDIT_EARTHQUAKE_EVENT });
export const createEarthquake = ({
  data, formModel, location, goBack, history,
}) => ({
  type: CREATE_EDIT_EARTHQUAKE_REQUEST, data, formModel, location, goBack, history,
});
export const updateEarthquake = ({
  data, id, formModel, location, goBack, history,
}) => ({
  type: UPDATE_EDIT_EARTHQUAKE_REQUEST, data, id, formModel, location, goBack, history,
});
export const searchVolcanoes = ({ queryParameters, history }) => ({
  type: EDIT_EARTHQUAKE_VOLCANO_SEARCH_REQUEST,
  queryParameters,
  history,
});
export const getVolcano = ({ id, history }) => ({ type: EDIT_EARTHQUAKE_VOLCANO_REQUEST, id, history });
export const searchTsunamis = ({ queryParameters, history }) => ({
  type: EDIT_EARTHQUAKE_TSUNAMI_SEARCH_REQUEST,
  queryParameters,
  history,
});
export const getTsunami = ({ id, history }) => ({ type: EDIT_EARTHQUAKE_TSUNAMI_REQUEST, id, history });
export const searchReferences = ({ queryParameters, history }) => ({
  type: EDIT_EARTHQUAKE_REFERENCE_SEARCH_REQUEST,
  queryParameters,
  history,
});
export const getReferences = ({ id, history }) => ({ type: EDIT_EARTHQUAKE_REFERENCE_REQUEST, id, history });

export const getRegions = ({ history }) => ({ type: EDIT_EARTHQUAKE_REGION_REQUEST, history });
export const getCountries = ({ history }) => ({ type: EDIT_EARTHQUAKE_COUNTRY_REQUEST, history });
export const getAreas = ({ history }) => ({ type: EDIT_EARTHQUAKE_AREA_REQUEST, history });
export const getLocations = ({ history }) => ({ type: EDIT_EARTHQUAKE_LOCATION_REQUEST, history });

export const sortVolcanoes = sort => ({ type: EDIT_EARTHQUAKE_VOLCANO_SORT, sort });
export const sortTsunamis = sort => ({ type: EDIT_EARTHQUAKE_TSUNAMI_SORT, sort });
export const sortReferences = sort => ({ type: EDIT_EARTHQUAKE_REFERENCE_SORT, sort });

export const openEditConfirmation = ({ formData }) => ({ type: EDIT_EARTHQUAKE_OPEN_CONFIRMATION, formData });
export const cancelEditConfirmation = () => ({ type: EDIT_EARTHQUAKE_CANCEL_CONFIRMATION });

export const toggleTsunamiColumns = visibleColumns => ({ type: EDIT_EARTHQUAKE_TSUNAMI_TOGGLE_COLUMN, visibleColumns });
export const toggleReferenceColumns = visibleColumns => ({ type: EDIT_EARTHQUAKE_REFERENCE_TOGGLE_COLUMN, visibleColumns });
export const toggleVolcanoColumns = visibleColumns => ({ type: EDIT_EARTHQUAKE_VOLCANO_TOGGLE_COLUMN, visibleColumns });
